import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const Cancel: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper 
    onClick={onClick}
    divClassName={divClassName}
  >
    <svg 
      width="17" 
      height="16" 
      viewBox="0 0 17 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M0.507954 0.0870662C0.296222 0.184137 0.162954 0.321704 0.0726807 0.536441C-0.0126944 0.739359 -0.0128253 0.87736 0.0721124 1.08176C0.119174 1.19512 1.15325 2.25121 3.53803 4.62152L6.93685 7.99974L3.51813 11.3999C-0.165687 15.0638 -0.0493025 14.9336 0.0222517 15.3125C0.0808158 15.6227 0.37976 15.9197 0.692 15.9779C1.07343 16.049 0.942352 16.1646 4.63019 12.505L8.05263 9.10875L11.4751 12.505C15.1629 16.1646 15.0318 16.049 15.4133 15.9779C15.7255 15.9197 16.0244 15.6227 16.083 15.3125C16.1546 14.9336 16.2709 15.0638 12.5873 11.4001L9.16867 8L12.5873 4.59993C16.2709 0.936193 16.1546 1.06642 16.083 0.687478C16.0244 0.377278 15.7255 0.0802876 15.4133 0.0221062C15.0318 -0.0489803 15.163 -0.164604 11.4749 3.49513L8.05237 6.89151L4.65193 3.5149C2.26602 1.14572 1.20298 0.118395 1.08887 0.0716411C0.876615 -0.0154355 0.722529 -0.0113078 0.507954 0.0870662Z" 
        fill="#F23C34"
      />
    </svg>

  </SvgWrapper>
);

